export default "__VITE_ASSET__6dcd0924__"